    import {
      Code2,
      Globe,
      Cloud,
      Wrench,
      Monitor,
      Shield,
      Languages,
      NotepadText,
      Bot,
    } from "lucide-react";
    import SkillCategory from "../types/SkillsCategory";
    /* Hard code in skills currently, need to invoke data from database later */
    
    const skillsData: SkillCategory[] =[
        {
            title: "Programming Languages",
            icon: <Code2 size={24} />,
            skills: ["C/C++", "Python", "Java", "C#", "JavaScript", "TypeScript", "SQL", "MySQL", "PostgreSQL"],
        },
        {
            title: "Web & Frameworks",
            icon: <Globe size={24} />,
            skills: ["MERN Stack", "React", "MUI", "Shadcn UI", "TailwindCSS", "Wireframe", "Figma", "ERD Design"],
        },
        {
            title: "Cloud & DevOps",
            icon: <Cloud size={24} />,
            skills: ["AWS EC2", "AWS S3", "Route 53", "Docker", "Caddy (Reverse Proxy)"],
        },
        {
            title: "Tools & Platforms",
            icon: <Wrench size={24} />,
            skills: ["Github", "JIRA", "Draw.io", "PowerPoint", "Excel", "Word", "Postman", "Swagger", "Canva", "Wireshark"],
        },
        {
            title: "Systems & CLI",
            icon: <Monitor size={24} />,
            skills: [
            "Unix-based CLI",
            "Windows CLI",
            "Virtual Machines (Parallels, VirtualBox)",
            "Git (VCS tool)",
            ],
        },
        {
            title: "Security & Privacy",
            icon: <Shield size={24} />,
            skills: [
            "Pseudonymisation",
            "K-anonymity",
            "Differential Privacy",
            "Salting Password",
            "Rate limit",
            "Basic Cryptography",
            ],
        },
        {
            title: "IDE",
            icon: <NotepadText size={24} />,
            skills: [
                "VScode",
                "Visual Studio 2022",
                "IntelliJ",
                "Pycharm",
                "Vim",
                "Neovim",
                "Eclipse",
            ]
        },
        {
            title: "AI agents",
            icon: <Bot size={24} />,
            skills: [
                "ChatGPT", 
                "Gemini",
                "DeepSeek",
                "Claude Code",
                "Copilot",
                "Codex",
                "Tinfoil => Private AI",
                "豆包",
            ],
        },
        {
            title: "Languages",
            icon: <Languages size={24} />,
            skills: ["English (Advanced)", "Chinese (Native)", "German (Beginner => A+ in German 101)"],
        },
    ];

export default skillsData;